import { getCurrentTime } from "@sa-nu/shared-utils/date";

function getLeadTimeKey() {
  return `rsv_form_entry_time`;
}

/**
 * 予約フォーム流入時刻を必要に応じて記録する
 * - 既存の流入時刻がない場合は記録
 * - 1時間以上経過している場合は再記録
 */
export function recordReservationFormEntryTimeIfNeeded(): void {
  if (typeof window === "undefined") return;

  const existingEntryTime = localStorage.getItem(getLeadTimeKey());
  const now = getCurrentTime().epochMilliseconds;
  const oneHourMs = 60 * 60 * 1000;

  const shouldSave =
    !existingEntryTime || now - parseInt(existingEntryTime, 10) >= oneHourMs;

  if (shouldSave) {
    localStorage.setItem(getLeadTimeKey(), now.toString());
  }
}

export function clearLeadTimeStorage() {
  if (typeof window !== "undefined") {
    localStorage.removeItem(getLeadTimeKey());
  }
}

export function getLeadTime(): {
  sec: number | null;
  bucket: string | null;
} {
  const empty = { sec: null, bucket: null };
  if (typeof window === "undefined") return empty;

  const entryTimeStr = localStorage.getItem(getLeadTimeKey());
  if (!entryTimeStr) return empty;

  const entryTime = parseInt(entryTimeStr, 10);
  if (isNaN(entryTime)) return empty;

  const elapsedMs = getCurrentTime().epochMilliseconds - entryTime;
  const bucket = getLeadTimeBucket(elapsedMs);
  return { sec: Math.round(elapsedMs / 1000), bucket };
}

/**
 * リードタイムをバケットに変換する関数
 */

export function getLeadTimeBucket(elapsedMs: number): string {
  const elapsedMin = elapsedMs / (1000 * 60);
  const elapsedHour = elapsedMin / 60;

  if (elapsedMin < 1) return "0-1min";
  if (elapsedMin < 2) return "1-2min";
  if (elapsedMin < 3) return "2-3min";
  if (elapsedMin < 4) return "3-4min";
  if (elapsedMin < 5) return "4-5min";
  if (elapsedMin < 6) return "5-6min";
  if (elapsedMin < 7) return "6-7min";
  if (elapsedMin < 8) return "7-8min";
  if (elapsedMin < 9) return "8-9min";
  if (elapsedMin < 10) return "9-10min";
  if (elapsedMin < 15) return "10-15min";
  if (elapsedMin < 20) return "15-20min";
  if (elapsedMin < 25) return "20-25min";
  if (elapsedMin < 30) return "25-30min";
  if (elapsedHour < 1) return "30min-1h";
  return "1h+";
}
